import { render, staticRenderFns } from "./FaultsTwinWidget.vue?vue&type=template&id=1b361253&scoped=true&"
import script from "./FaultsTwinWidget.vue?vue&type=script&lang=js&"
export * from "./FaultsTwinWidget.vue?vue&type=script&lang=js&"
import style0 from "./FaultsTwinWidget.vue?vue&type=style&index=0&id=1b361253&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b361253",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!G:/www-purejs/EdsOnLineMobile/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAvatar,VCard,VCardActions,VCardTitle,VContainer,VFlex,VIcon,VLayout})
